module.exports = __webpack_public_path__ + "media/connectivity-hero.b5a584ee.mp4";